import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/content';
import { SectionCta } from '../SectionCta';
export function Testimonials() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-238" data-mp="3mgsgvvj1yn4m">
      <div className="mx-auto max-w-5xl" data-id="element-239" data-mp="3mfhfg2d2xrgo">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-teal-600" data-id="element-240" data-mp="3r78zrv5n70yd">
          ⭐ What other physicians are saying
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy-800 sm:text-4xl" data-id="element-241" data-mp="3ahufi4mglo">
          Join <em className="italic text-teal-600" data-id="element-242" data-mp="91w7eum0mvvy">1,200+ physicians</em> using Dr. Karito's
          clinical organization systems
        </h2>

        <div className="mt-6 flex items-center justify-center gap-2" data-id="element-243" data-mp="dzxs1jz3b39j">
          <div className="flex gap-0.5" aria-hidden="true" data-id="element-244" data-mp="2atiuil2se6n5">
            {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-5 w-5 fill-amber-400 text-amber-400" data-id="element-245" data-mp="2fru2srdfo939" />)}
          </div>
          <span className="text-[15px] font-bold text-navy-800" data-id="element-246" data-mp="1sksxm9pz5ove">4.9/5</span>
        </div>

        <ul className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-247" data-mp="1ntawnlnyboaf">
          {testimonials.map((person, index) => <li key={person.name} className={`flex flex-col rounded-2xl border border-navy-100 bg-cream p-5 ${index === testimonials.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-248" data-mp="1ity4cleb9p0g" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-249" data-mp="2bhat927y28wx">
                <img src={person.photo} alt={`Photo of ${person.name}`} className="h-14 w-14 shrink-0 rounded-full object-cover" width={112} height={112} loading="lazy" data-id="element-250" data-mp="26lddax0lf4ko" />
                <div data-id="element-251" data-mp="r3tnuxto9m4i">
                  <p className="text-[15px] font-bold text-navy-800" data-id="element-252" data-mp="r54v57mbtc0d">{person.name}</p>
                  <p className="text-[13px] font-medium text-navy-700/70" data-id="element-253" data-mp="m3fkht30n0ct">
                    <span aria-hidden="true" data-id="element-254" data-mp="nl4fwkcrvd7e">{person.flag}</span> {person.country}
                  </p>
                </div>
              </div>
              <blockquote className="mt-4 flex-1 text-[14px] leading-relaxed text-navy-700/85 sm:text-[15px]" data-id="element-255" data-mp="sjxsmak8j06i">
                "{person.quote}"
              </blockquote>
            </li>)}
        </ul>

        <SectionCta label="I want to feel this organized" data-id="element-256" data-mp="iomcpox3bmx6" />
      </div>
    </section>;
}